export const LEGACY_GIFT_CARD_FREE_SHIPPING = 'legacy-gift-cards-freeshipping';
export const LEGACY_GIFT_CARDS_KEY = 'legacy-gift-cards';
